import { render, staticRenderFns } from "./CbsNxzBudgetRequest.vue?vue&type=template&id=1b511cf6&scoped=true"
import script from "./CbsNxzBudgetRequest.vue?vue&type=script&lang=js"
export * from "./CbsNxzBudgetRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b511cf6",
  null
  
)

export default component.exports